import React, { useState } from "react";
import "./pdfViewer.scss";

const PDFDrawToolbar = ({
  onSave,
  onClose,
  onToolChange,
  selectedTool,
  selectedColor,
  onColorChange,
  brushSize,
  onBrushSizeChange,
  onUndo,
  onRedo,
  canUndo = false,
  canRedo = false,
  theme = "light",
  isSaving = false,
  saveProgress = 0,
  hasChanges = false
}) => {
  const [showColorPicker, setShowColorPicker] = useState(false);

  const colors = [
    "#000000", // Black
    "#FF0000", // Red
    "#00FF00", // Green
    "#0000FF", // Blue
    "#FFFF00", // Yellow
    "#FF00FF", // Magenta
    "#00FFFF", // Cyan
    "#FFA500", // Orange
    "#800080", // Purple
    "#FFC0CB", // Pink
  ];

  const tools = [
    { id: "pen", label: "Draw", icon: "✏️" },
    { id: "highlighter", label: "Highlighter", icon: "🖍️" },
  ];

  return (
    <div className="pdf-draw-toolbar" data-theme={theme}>
      <div className="pdf-draw-toolbar-left">
        {tools.map((tool) => (
          <button
            key={tool.id}
            className={`pdf-draw-tool-button ${selectedTool === tool.id ? "active" : ""}`}
            onClick={() => onToolChange(tool.id)}
            title={tool.label}
          >
            <span className="pdf-draw-tool-icon">{tool.icon}</span>
            <span className="pdf-draw-tool-label">{tool.label}</span>
          </button>
        ))}

        {/* Color Picker */}
        <div className="pdf-draw-color-picker-container">
          <button
            className="pdf-draw-color-button"
            onClick={() => setShowColorPicker(!showColorPicker)}
            title="Select color"
          >
            <div
              className="pdf-draw-color-preview"
              style={{ backgroundColor: selectedColor }}
            />
            <span>Color</span>
          </button>
          {showColorPicker && (
            <div className="pdf-draw-color-picker">
              {colors.map((color) => (
                <button
                  key={color}
                  className={`pdf-draw-color-option ${selectedColor === color ? "selected" : ""}`}
                  style={{ backgroundColor: color }}
                  onClick={() => {
                    onColorChange(color);
                    setShowColorPicker(false);
                  }}
                  title={color}
                />
              ))}
            </div>
          )}
        </div>

        {/* Brush Size Control */}
        <div className="pdf-draw-brush-size-container">
          <label className="pdf-draw-brush-size-label">Size:</label>
          <input
            type="range"
            min="2"
            max="50"
            value={brushSize}
            onChange={(e) => onBrushSizeChange(parseInt(e.target.value))}
            className="pdf-draw-brush-size-slider"
            title={`Brush size: ${brushSize}px`}
          />
          <span className="pdf-draw-brush-size-value">{brushSize}px</span>
        </div>

        {/* Undo/Redo Controls */}
        <div className="pdf-draw-undo-redo-container">
          <button
            className="pdf-draw-undo-button"
            onClick={onUndo}
            disabled={isSaving || !canUndo}
            title={isSaving ? "Cannot undo while saving" : "Undo"}
          >
            ↶ Undo
          </button>
          <button
            className="pdf-draw-redo-button"
            onClick={onRedo}
            disabled={isSaving || !canRedo}
            title={isSaving ? "Cannot redo while saving" : "Redo"}
          >
            ↷ Redo
          </button>
        </div>
      </div>

      <div className="pdf-draw-toolbar-right">
        <button
          className="pdf-draw-save-button"
          onClick={onSave}
          title={hasChanges ? (isSaving ? `Saving... ${saveProgress}%` : "Save changes") : "No changes to save"}
          disabled={isSaving || !hasChanges}
        >
          {isSaving ? (
            <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span>Saving...</span>
              {saveProgress > 0 && (
                <span style={{ fontSize: "12px", opacity: 0.8 }}>{saveProgress}%</span>
              )}
            </span>
          ) : (
            "Save"
          )}
        </button>
        <button
          className="pdf-draw-close-button"
          onClick={onClose}
          title={isSaving ? "Cancel save and close" : "Close"}

        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default PDFDrawToolbar;

